<template>

  <div>
  
    <!-- <div class="pesquisa">
    <label> Procurar por:</label><input class="form-control" v-model="searchTerm" />
    </div> -->

   <TableLite
   :is-static-mode="true"
    :columns="columns"
    :rows="rows"
    :total="totalRecordCount"
    :sortable="sortable"
   />

  </div>
</template>

<script>
import TableLite from '../../../components/Tables/Table-Simple.vue'
import {GetDataAllMolde } from "../../../controllers/Molde/GetDataAllMolde"
export default {
components : { TableLite },
async created(){
  const res = await GetDataAllMolde();
  if(res){
    this.data = res.data.list
  }

},
data(){
  return {
   isLoading : false,
   searchTerm : "",
   columns : [
     
     {
       label : "Molde",
       field : "numero_molde",
       width : "8%",
       sortable : true
     },
     {
     label : "Fabricante",
     field : "fabricante",
     width : "12%",
     sortable : true,
     isKey : true,
     },
     {
       label : "Cliente",
       field : "nome",
       width : "15%",
       sortable : true,
     },

   ],

   data : [],

   sortable : {
     order : "id",
     sort : "asc"
   },
   }
   },
   computed : {

     totalRecordCount(){

       return this.rows.length;
     },

      rows() {
        return this.data.filter( (x) =>
            x.numero_molde.includes(this.searchTerm)
        );
      }
      

   }

}
</script>

<style scoped>

.table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid var(--cinza);
}

.pesquisa{
  
    /* text-align: left; */
    display: flex;
    justify-content: end;
    align-items: center;
}


</style>
